import React, { useEffect, useState } from "react";
import "./Admin.css";

function PregledRezervacij() {
    const [rezervacije, setRezervacije] = useState([]);
    const [loading, setLoading] = useState(true);
    const [napaka, setNapaka] = useState(null);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/rezervacije`)
            .then((res) => {
                if (!res.ok) {
                    throw new Error("Napaka pri pridobivanju rezervacij.");
                }
                return res.json();
            })
            .then((data) => {
                setRezervacije(data);
                setLoading(false);
            })
            .catch((err) => {
                setNapaka(err.message);
                setLoading(false);
            });
    }, []);

    if (loading) return <h2 style={{ marginTop: "5em" }}>Nalaganje...</h2>;
    if (napaka) return <h2>Napaka: {napaka}</h2>;

    const formatirajDatum = (datum) => {
        const meseci = ["januar", "februar", "marec", "april", "maj", "junij", "julij", "avgust", "september", "oktober", "november", "december"];
        const date = new Date(datum);
        const ure = date.getHours().toString().padStart(2, "0");
        const minute = date.getMinutes().toString().padStart(2, "0");
        return `${date.getDate()}. ${meseci[date.getMonth()]} ob ${ure}:${minute}`;
    };


    const zdruzenePoKoncertih = rezervacije.reduce((acc, rezervacija) => {
        const { koncertId, koncertIme, koncertDatum, ime, email, steviloVstopnic, vir } = rezervacija;
        if (!acc[koncertId]) {
            acc[koncertId] = {
                koncertIme,
                koncertDatum,
                rezervacije: [],
                skupno: 0,
            };
        }
        acc[koncertId].rezervacije.push({ ime, email, steviloVstopnic, vir });
        acc[koncertId].skupno += parseInt(steviloVstopnic);
        return acc;
    }, {});

    return (
        <div className="pregled-rezervacij-container">
            <h1>Pregled rezervacij</h1>
            {Object.entries(zdruzenePoKoncertih)
                .sort((a, b) => new Date(b[1].koncertDatum) - new Date(a[1].koncertDatum))
                .map(([koncertId, data]) => (
                <div key={koncertId} className="rezervacija-kartica">
                    <div className="center-skp">
                        <h2>{data.koncertIme}</h2>
                        <p>{formatirajDatum(data.koncertDatum)}</p>
                    </div>
                    <table>
                        <thead>
                        <tr>
                            <th>Ime/mail</th>
                            <th>Koliko</th>
                            <th>Iz kje</th>
                        </tr>
                        </thead>
                        <tbody>
                        {data.rezervacije.map((r, index) => (
                            <tr key={index}>
                                <td>{r.ime} - {r.email}</td>
                                <td>{r.steviloVstopnic} vstopnic/e</td>
                                <td>{r.vir}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <p className="skupno-vstopnic">
                        Skupaj rezerviranih vstopnic: <strong>{data.skupno}</strong>
                    </p>
                </div>
            ))}
        </div>

    );
}

export default PregledRezervacij;
